import { TableFilters } from '../../../../../../components'
import { useListView } from '../../core/ListViewProvider'
import { RiscoClienteListGrouping } from './RiscoClienteListGrouping'
import { RiscoClienteListToolbar } from './RiscoClienteListToolbar'

/**
 * Riscos não têm campo de busca (o endpoint não filtra por nome): a barra só carrega as
 * ações — "Adicionar" ou a seleção em lote — no canto direito, como nas demais listagens.
 */
export const RiscoClienteListHeader = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <TableFilters
        actions={selected.length > 0 ? <RiscoClienteListGrouping /> : <RiscoClienteListToolbar />}
      >
        {null}
      </TableFilters>
    </div>
  )
}
